export default {"src":"/_next/static/media/Seon.dacab356.svg","height":60,"width":60};